import { useAppSelector } from "../../Redux/Hooks/hooks.redux";
export function useBoxUrl(): string{
    const {appAuthState} = useAppSelector((state)=>(state.appState))
    return appAuthState.boxURL
}